import ZEntity from '@/ZForms/parsers/entities/ZEntity.js';


export default window.ZForms.registerClass('action', class ZAction extends ZEntity {
  constructor() {
    super(...arguments);
    this.actionData = null;
    this.triggerType = null;
  }

  _updateParamsFromRaw(rawData) {
    super._updateParamsFromRaw(rawData);
    this.actionData = rawData.data === undefined ? this.actionData : rawData.data;
    this.triggerType = rawData.trigger_type === undefined ? this.triggerType : rawData.trigger_type;
  }

  packResponse() {
    const ans = {
      uid: this.getUid(),
    };

    if (this.actionData != null) {
      ans.data = this.actionData;
    }

    return ans;
  }

  hasTrigger(triggerType) {
    if (this.triggerType == triggerType) return this;
    return null;
  }
});
